import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase URL and Anon Key must be provided in environment variables.');
  throw new Error('Supabase URL and/or Anon Key missing!');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, { auth: { storageKey: 'syncehs-auth-token' } });
